var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_3055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.375 11.25C12.5802 11.25 11.8497 11.5249 11.273 11.9846L7.66998 9.73269C7.77668 9.25005 7.77668 8.74992 7.66998 8.26727L11.273 6.01538C11.8497 6.47511 12.5802 6.75 13.375 6.75C15.2389 6.75 16.75 5.23895 16.75 3.375C16.75 1.51105 15.2389 0 13.375 0C11.5111 0 10 1.51105 10 3.375C10 3.62665 10.0278 3.87176 10.08 4.10769L6.47699 6.35959C5.90032 5.89989 5.16981 5.625 4.375 5.625C2.51105 5.625 1 7.13605 1 9C1 10.8639 2.51105 12.375 4.375 12.375C5.16981 12.375 5.90032 12.1001 6.47699 11.6404L10.08 13.8923C10.0268 14.1329 9.99993 14.3786 10 14.625C10 16.4889 11.5111 18 13.375 18C15.2389 18 16.75 16.4889 16.75 14.625C16.75 12.7611 15.2389 11.25 13.375 11.25Z",
    fill: "#B1BAD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_3055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 18,
    fill: "white",
    transform: "translate(1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d890eb758fc958335ab2c69eba639b9e.svg";
export { ForwardRef as ReactComponent };